import {
  CHAPTER,
  ChapterDefinition,
  ChapterSelectionDefinition,
  CHAPTER_SELECTION,
  IMAGE,
  ImageDefinition,
  LayoutListDefinition,
  LAYOUT_LIST,
  TEXT,
  TextDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const Interactive11: Translator = sequence => {
  // TODO: the API data I had does not include the text bits that are visible in Figma. The items for those will need
  // to be added later...
  const chapterSelection: ChapterSelectionDefinition = {
    id: `${sequence.id}.cs`,
    type: CHAPTER_SELECTION,
    values: void {},
    items: []
  };
  const root = translate(sequence, item => {
    if (item.__typename !== 'Card') return null;

    chapterSelection.items.push({
      id: item.id,
      type: CHAPTER,
      values: {
        value: item.branchSequenceId
      },
      items: [
        ...(item.pictures || []).map(
          p =>
            ({
              id: p.id,
              type: IMAGE,
              values: {
                imageGenerationPlacement: 'card_image',
                url: p.mediaUrl,
                alt: p.name || item.title
              }
            }) as ImageDefinition
        ),
        {
          id: `${item.id}_title`,
          type: TEXT,
          values: {
            variant: 'heading3',
            value: item.title
          }
        } as TextDefinition
      ]
    } as ChapterDefinition);

    return null;
  });

  root.items.push({
    id: `${sequence.id}.layout`,
    type: LAYOUT_LIST,
    values: {
      align: 'center'
    },
    items: [chapterSelection]
  } as LayoutListDefinition);

  return root;
};
